export default "__VITE_ASSET___xr2$ywl__"